/* Graph of Life brand v1.1.0 · tokens.json */
import React from 'react';

const Field = ({ label, value }) => (
  <div className="space-y-1">
    <dt className="font-mono text-[10px] uppercase tracking-[0.2em] text-sand-50/30">{label}</dt>
    <dd className="font-mono text-[11px] leading-relaxed text-sand-50/60">{value || 'not established'}</dd>
  </div>
);

export const ProvenanceLine = ({ source, method, confidence, intendedUse, lastVerified, testId }) => (
  <div data-testid={testId} className="relative z-10 border-t border-abyss-800 pt-5 mt-6 space-y-4">
    <div className="flex items-center gap-3">
      <div className="gol-hairline w-8" aria-hidden="true" />
      <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-teal-500">
        SOURCE · METHOD · CONFIDENCE · USE
      </p>
    </div>
    <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
      <Field label="Source" value={source} />
      <Field label="Method" value={method} />
      <Field label="Confidence" value={confidence} />
      <Field label="Intended use" value={intendedUse} />
    </dl>
    {lastVerified && (
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-sand-50/25">Last verified {lastVerified}</p>
    )}
  </div>
);

export default ProvenanceLine;
